import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';

type Props = DialogProps;

const TournamentEnd = (props: Props) => {
  const {toggle, modalOpen} = props;

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="dialog-logout">
      <DialogTitle id="dialog-title">TORNEO FINALIZADO</DialogTitle>
      <DialogContent>
        <DialogContentText>
          El torneo ha llegado hasta su ultima ronda, no es posible generar una
          ronda más.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => toggle()} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TournamentEnd.displayName = 'TournamentEnd';

export default TournamentEnd;
